import FilterButtonsInstance from './FilterButtonInstance';

const filterButtonContainers = document.querySelectorAll( '.filter-buttons' );

if ( filterButtonContainers ) {
	filterButtonContainers.forEach( container => new FilterButtonsInstance( container ) );
}
